import React from "react";
import ObsIframe from "../../../iframe-component/onboarding/ObsIframe";

const PendingInstallation = () => {
  return <ObsIframe path="/tasklist/installation-pending-task" />;
};

export default React.memo(PendingInstallation);
